<template>
    <div class="view-container">
        <modal :showDialog="(activeModal == ActiveModal.AddEdit)" @close="closeModal" :title="selectedElement == null ? $t('AddSolution') : $t('EditSolution')">
            <solution-modal @saved="closeModal" :existingElement="selectedElement"/>
        </modal>
        <modal :showDialog="(activeModal == ActiveModal.Preview)" @close="closeModal" :title="$t('PreviewSolution')">
            <solution-preview-modal v-if="(selectedElement != null && activeModal == ActiveModal.Preview)" :solutionObject="selectedElement" :problemTitle="selectedElement.problemTitle"/>
        </modal>
        <modal :showDialog="selectedElement != null && ActiveModal.Delete == activeModal" @close="closeModal" :title="'Delete Solution'">
            <delete-confirm v-if="selectedElement != null && ActiveModal.Delete == activeModal" @cancel="closeModal" @confirm="deleteSolution" :text="'Delete Solution for problem: ' + (selectedElement == null ? 'unknown' : selectedElement.problemTitle)"></delete-confirm>
        </modal>
        <modal :showDialog="(activeModal == ActiveModal.ConfirmBox)" @close="closeModalOnly" >
          <info-confirm :text="confirmBoxText" @confirm="closeModalOnly"/>
        </modal>
        <div :class="{'two-columns-template' : (visitId != null || problemId != null)}">
            <div style="width: 100%; height: 100%; overflow-x: auto">
                <div class="max-grid">
                    <ejs-grid ref="grid" height='100%' width='100%' :toolbar='toolbar' :toolbarClick='toolbarClick' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="solutions" :allowPaging="true" :pageSettings='pageSettings' :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
                        <e-columns>
                            <e-column field='systemName' :headerText="$t('SystemName')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                            <e-column field='creatorName' :headerText="$t('CreatedBy')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                            <e-column field='deviceName' :headerText="$t('Device')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                            <e-column field='problemTitle' :headerText="$t('ProblemTitle')" textAlign='Left' :customAttributes="customAttributes" :filter="filterOptions"></e-column>
                            <e-column field='systemStatusCheck' :headerText="$t('SystemStatusCheck')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                            <e-column field='createDate' :headerText="$t('Created')" textAlign='Left' type="datetime" :format="dateTimeFormatOptions" :customAttributes="customAttributes"></e-column>
                            <e-column field='resolveDate' :headerText="$t('Resolved')" textAlign='Left' type="datetime" :format="dateTimeFormatOptions" :customAttributes="customAttributes"></e-column>
                            <e-column :headerText="''" :template="ButtonsTemplate" :allowFiltering="false" :allowSorting="false" :customAttributes="customAttributes" width="100px"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
            <div v-if="visitId != null" class="system-info-container">
                <div>
                  <h4>{{ $t('VisitInfo') }}</h4>
                  <div>
                      <div class="system-details-container">
                          <h5>{{ $t('BaseInfo') }}</h5>
                          <div class="info-field horizontal">
                              <tr class="info-field-row">
                                  <td style="width:200px;"><p class="info-field-title">{{ $t('FarmName') }}</p></td>
                                  <td style="width:200px;" class="info-field-value">
                                      <div class="info-field-text">{{visit.farmName}}</div>
                                  </td>
                              </tr>
                          </div>
                          <div class="info-field horizontal">
                              <tr class="info-field-row">
                                  <td style="width:200px;"><p class="info-field-title">{{ $t('Description') }}</p></td>
                                  <td style="width:200px;" class="info-field-value">
                                      <div class="info-field-text">{{visit.description}}</div>
                                  </td>
                              </tr>
                          </div>
                          <div class="info-field horizontal">
                              <tr class="info-field-row">
                                  <td style="width:200px;"><p class="info-field-title">{{ $t('MainAssignee') }}</p></td>
                                  <td style="width:200px;" class="info-field-value">
                                      <div class="info-field-text">{{visit.mainAssigneeName}}</div>
                                  </td>
                              </tr>
                          </div>
                          <div class="info-field horizontal">
                              <tr class="info-field-row">
                                  <td style="width:200px;"><p class="info-field-title">{{ $t('PlannedFrom') }}</p></td>
                                  <td style="width:200px;" class="info-field-value">
                                      <div class="info-field-text">{{moment(visit.dateFrom).format('YYYY-MM-DD')}}</div>
                                  </td>
                              </tr>
                          </div>
                          <div class="info-field horizontal">
                              <tr class="info-field-row">
                                  <td style="width:200px;"><p class="info-field-title">{{ $t('PlannedTo') }}</p></td>
                                  <td style="width:200px;" class="info-field-value">
                                      <div class="info-field-text">{{moment(visit.dateTo).format('YYYY-MM-DD')}}</div>
                                  </td>
                              </tr>
                          </div>
                          <div class="info-field horizontal">
                              <tr class="info-field-row">
                                  <td style="width:200px;"><p class="info-field-title">{{ $t('Started') }}</p></td>
                                  <td style="width:200px;" class="info-field-value">
                                      <div class="info-field-text">{{moment(visit.started).format('YYYY-MM-DD')}}</div>
                                  </td>
                              </tr>
                          </div>
                          <div class="info-field horizontal">
                              <tr class="info-field-row">
                                  <td style="width:200px;"><p class="info-field-title">{{ $t('Ended') }}</p></td>
                                  <td style="width:200px;" class="info-field-value">
                                      <div class="info-field-text">{{moment(visit.ended).format('YYYY-MM-DD')}}</div>
                                  </td>
                              </tr>
                          </div>
                      </div>
                  </div>
                </div>
            </div>
            <div v-else-if="problemId != null" class="system-info-container">
                  <div>
                    <h4>{{ $t('ProblemInfo') }}</h4>
                    <div>
                        <div class="system-details-container">
                            <h5>{{ $t('BaseInfo') }}</h5>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width:200px;"><p class="info-field-title">{{ $t('SystemName') }}</p></td>
                                    <td style="width:200px;" class="info-field-value">
                                        <div class="info-field-text">{{ problem.systemName }}</div>
                                    </td>
                                </tr>
                            </div>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width:200px;"><p class="info-field-title">{{ $t('Device') }}</p></td>
                                    <td style="width:200px;" class="info-field-value">
                                        <div class="info-field-text">{{ problem.deviceName }}</div>
                                    </td>
                                </tr>
                            </div>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width:200px;"><p class="info-field-title">{{ $t('Title') }}</p></td>
                                    <td style="width:200px;" class="info-field-value">
                                        <div class="info-field-text">{{ problem.title }}</div>
                                    </td>
                                </tr>
                            </div>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width:200px;"><p class="info-field-title">{{ $t('Description') }}</p></td>
                                    <td style="width:200px;" class="info-field-value">
                                        <div class="info-field-text">{{ problem.description }}</div>
                                    </td>
                                </tr>
                            </div>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width:200px;"><p class="info-field-title">{{ $t('ReportedDate') }}</p></td>
                                    <td style="width:200px;" class="info-field-value">
                                        <div class="info-field-text">{{ moment(problem.reportedDate).format('YYYY-MM-DD') }}</div>
                                    </td>
                                </tr>
                            </div>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width:200px;"><p class="info-field-title">{{ $t('ResolvedDate') }}</p></td>
                                    <td style="width:200px;" class="info-field-value">
                                        <div class="info-field-text">{{ moment(problem.resolvedDate).format('YYYY-MM-DD') }}</div>
                                    </td>
                                </tr>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
        </div>
    </div>
</template>

<script>
import { getSolutions, deleteSolution, getSolutionsForVisit, getVisit, getSolutionsForProblem, getProblem } from '@/api/api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import { VisitsActiveModal } from '@/Models/VisitsActiveModal'
import Modal from '../../components/Modal.vue';
import SolutionModal from '../../components/Visits/Solutions/SolutionModal.vue';
import SolutionPreviewModal from '../../components/Visits/Solutions/SolutionPreviewModal.vue';
import SolutionsTableButtonsVue from '../../components/Visits/Solutions/SolutionsTableButtons.vue';
import DeleteConfirm from '../../components/DeleteConfirm.vue';
import InfoConfirm from '@/components/InfoConfirm.vue';;

var self = null

export default {
    provide: {
        grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport]
    },
    props: {
        visitId: {
            type: String, default: null, require: false
        },
        systemId: {
            type: String, default: null, require: false
        },
        problemId: {
            type: String, default: null, require: false
        },
        systemName: {
          type: String, default: null, require: false
        }
    },
    components: {
        SolutionModal,
        Modal,
        SolutionPreviewModal,
        DeleteConfirm,
        InfoConfirm
    },
    data() {
        return {
            visit: {
                farmId: '',
                farmName: '',
                dateFrom: null,
                dateTo: null,
                description: '',
                mainAssigneeId: '',
                mainAssigneeName: ''
            },
            problem: {},
            solutions: [],
            ActiveModal: {},
            activeModal: 'None',
            selectedElement: null,
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right', },
                { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' },
                { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' },
                { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' },
                { text: this.$t('EditSolution'), tooltipText: this.$t('EditSolution'), prefixIcon: 'e-edit', id: 'editSolution', align: 'Right'},
                'Search',
            ],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu",
                columns: this.systemName != null ? [{ field: 'systemName', matchCase: false, operator: 'equal', value: this.systemName }] : null
            },
            filterCheckBox: {
                type: "CheckBox",
            },
            customAttributes: { class: 'customcss' },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
            confirmBoxText: "",
            ButtonsTemplate: function() {
                return {
                    template: {
                        extends: SolutionsTableButtonsVue,
                        propsData: {
                            show(data, mode){
                                switch(mode){
                                    case 'PREVIEW':
                                        self.selectedElement = data
                                        self.activeModal = self.ActiveModal.Preview
                                        break;
                                    case 'DELETE':
                                        self.selectedElement = data
                                        self.activeModal = self.ActiveModal.Delete
                                        break;
                                }
                            }
                        }
                    },
                };
            },
        }
    },
    methods: {
        async getData() {
            var result = []
            if(this.visitId != null){
                result = await getSolutionsForVisit(this.visitId)
                this.visit = await getVisit(this.visitId)

                if(this.visit.ended == null){
                    this.toolbar.push(
                        { text: this.$t('AddSolution'), tooltipText: this.$t('AddSolution'), prefixIcon: 'e-add', id: 'addSolution', align: 'Right' },
                    )
                }
            } else if (this.problemId != null) {
              result = await getSolutionsForProblem(this.problemId)
              this.problem = await getProblem(this.problemId);
            } else {
                result = await getSolutions()
            }
            this.solutions = result
        },
        closeModalOnly() {
          this.activeModal = this.ActiveModal.None;
        },
        closeModal() {
            this.activeModal = this.ActiveModal.None;
            this.selectedElement = null
            this.getData();
        },
        async deleteSolution() {
            this.activeModal = this.ActiveModal.None
            await deleteSolution(this.selectedElement.id)
            this.selectedElement = null
            this.getData()
        },
        toolbarClick(args) {
            switch (args.item.id) {
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
                case "addSolution":
                    this.activeModal = this.ActiveModal.AddEdit;
                    break;
                case "editSolution":
                    var selectedRecords = this.$refs.grid.getSelectedRecords()
                    if(selectedRecords.length > 1) {
                        this.confirmBoxText = 'More than one record is selected.';
                        this.activeModal = this.ActiveModal.ConfirmBox;
                        break;
                    } else if (selectedRecords.length == 0) {
                        this.confirmBoxText = 'Nothing is selected.';
                        this.activeModal = this.ActiveModal.ConfirmBox;
                        break;
                    }
                    this.selectedElement = selectedRecords[0]
                    this.activeModal = this.ActiveModal.AddEdit
                    break;
            }
        },
        dataBound() {
            this.$refs.grid.autoFitColumns();
        },
    },
    async mounted() {
        self = this;
        this.ActiveModal = VisitsActiveModal
        this.activeModal = this.ActiveModal.None
        this.getData()
    }
}
</script>

<style scoped>
.system-info-container {
    background-color: rgba(243, 243, 243, 1);
	padding: 20px;
    border: 1px solid rgba(224, 224, 224, 1);
	border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.system-details-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.info-field-text {
    font-weight: bolder;
    word-break: break-word;
}

.two-columns-template {
    display: grid;
    grid-template-columns: 80% 20%;
}
</style>



// WEBPACK FOOTER //
// src/views/Visits/Solutions.vue